import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Async Html",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-async-html",
    args: { debug: false, replace: false, src: "null" },
    argTypes: {
        debug: { control: "boolean" },
        replace: { control: "boolean" },
        src: { control: "text" },
    },
};

const Template = ({ debug, replace, src }) =>
    html`<ux-iws-async-html
        debug="${debug}"
        replace="${replace}"
        src="${src}"
    ></ux-iws-async-html>`;

export const Default = Template.bind({});
Default.args = {
    debug: false,
    replace: false,
    src: "./mock-data/async-html/async-html.html",
};

export const Replace = Template.bind({});
Replace.args = {
    debug: false,
    replace: true,
    src: "./mock-data/async-html/async-html.html",
};
